import { useState } from "react";

export default function DownloadCta() {
  const [copied, setCopied] = useState(false);

  return (
    <section id="download" className="w-full border-t border-background-200 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="overflow-hidden rounded-2xl bg-primary-500">
          <div className="grid grid-cols-1 gap-10 p-7 md:p-12 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1.5 text-xs font-medium text-background-50">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-smartphone-line"></i>
                </span>
                App 下载入口 · 版本 3.2.0
              </span>
              <h3 className="mt-5 font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
                把黑料社区装进手机，实时追话题更方便
              </h3>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-50/85 md:text-base">
                圈子、话题、标签、群组四类入口在移动端一键直达，热门话题与快讯流同步更新，随时进入对应分区，找到同好一起深挖。
              </p>

              <div className="mt-7 flex flex-wrap gap-3">
                <button
                  type="button"
                  className="flex cursor-pointer items-center gap-3 whitespace-nowrap rounded-lg bg-foreground-950 px-5 py-3 text-left transition-colors hover:bg-foreground-900"
                >
                  <span className="flex h-6 w-6 items-center justify-center text-background-50">
                    <i className="ri-apple-fill text-xl"></i>
                  </span>
                  <span className="leading-tight">
                    <span className="block text-[10px] text-background-50/60">iOS 版</span>
                    <span className="text-sm font-medium text-background-50">App Store 下载</span>
                  </span>
                </button>

                <button
                  type="button"
                  className="flex cursor-pointer items-center gap-3 whitespace-nowrap rounded-lg border border-background-50/35 px-5 py-3 text-left transition-colors hover:bg-background-50/10"
                >
                  <span className="flex h-6 w-6 items-center justify-center text-background-50">
                    <i className="ri-android-fill text-xl"></i>
                  </span>
                  <span className="leading-tight">
                    <span className="block text-[10px] text-background-50/60">Android 版</span>
                    <span className="text-sm font-medium text-background-50">安装包下载</span>
                  </span>
                </button>

                <button
                  type="button"
                  onClick={() => setCopied(true)}
                  className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-lg border border-background-50/35 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className={copied ? "ri-check-line" : "ri-links-line"}></i>
                  </span>
                  {copied ? "链接已复制" : "复制下载链接"}
                </button>
              </div>

              <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-50/80">
                <span className="flex items-center gap-1.5">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-shield-check-line"></i>
                  </span>
                  官方安全下载通道
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-notification-3-line"></i>
                  </span>
                  热门话题订阅提醒
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-device-line"></i>
                  </span>
                  移动端专属分区入口
                </span>
              </div>
            </div>

            <div className="flex justify-center lg:justify-end">
              <div className="flex w-full max-w-md items-center gap-5 rounded-xl bg-background-50 p-4 md:p-5">
                <div className="h-40 w-28 shrink-0 overflow-hidden rounded-lg border border-background-200 bg-background-100 md:h-48 md:w-32">
                  <img
                    src="https://readdy.ai/api/search-image?query=smartphone%20mockup%20showing%20abstract%20community%20app%20feed%20interface%20on%20warm%20cream%20background%2C%20editorial%20product%20photography%2C%20soft%20diffused%20light%2C%20muted%20warm%20palette%2C%20minimal%20composition&width=600&height=900&seq=app-preview-01&orientation=portrait"
                    alt="黑料社区 App 界面预览"
                    title="黑料社区 App 移动端 话题分区"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0">
                  <p className="font-heading text-base font-bold text-foreground-950">App 界面预览</p>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                    首页即快讯流，圈子、话题、标签、群组四类入口固定在顶部，追话题不用来回切换。
                  </p>
                  <div className="mt-3 flex items-center gap-3 border-t border-background-200 pt-3">
                    <div>
                      <p className="font-heading text-lg font-bold text-primary-600">4.9</p>
                      <p className="text-[10px] text-foreground-500">平均评分</p>
                    </div>
                    <div className="h-8 w-px bg-background-200"></div>
                    <div>
                      <p className="font-heading text-lg font-bold text-primary-600">38万+</p>
                      <p className="text-[10px] text-foreground-500">累计安装</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}